import { mapState } from 'vuex';

/**
 * Create comment node
 *
 * @private
 * @author https://stackoverflow.com/questions/43003976/a-custom-directive-similar-to-v-if-in-vuejs#43543814
 */
/* eslint-disable no-param-reassign */
function commentNode(el, vnode) {
  const comment = document.createComment(' ');

  Object.defineProperty(comment, 'setAttribute', {
    value: () => undefined,
  });

  vnode.text = ' ';
  vnode.elm = comment;
  vnode.isComment = true;
  vnode.context = undefined;
  vnode.tag = undefined;
  vnode.data.directives = undefined;

  if (vnode.componentInstance) {
    vnode.componentInstance.$el = comment;
  }

  if (el.parentNode) {
    el.parentNode.replaceChild(comment, el);
  }
}
/* eslint-enable no-param-reassign */

function permissionsDirective(el, binding, vnode) {
  const resource = binding.arg.toLowerCase();
  const permissions = Object.keys(binding.modifiers);
  const allowed = vnode.context.hasPermissions(permissions, resource);

  if (!allowed) {
    commentNode(el, vnode);
  }
}

export default {
  computed: {
    ...mapState(['userPermissions']),
  },
  directives: {
    permissions: {
      bind: permissionsDirective,
      update: permissionsDirective,
    },
  },
  methods: {
    hasPermissions(permissions, resource) {
      if (!(this.userPermissions instanceof Object)) return false;
      if (!(this.userPermissions[resource] instanceof Array)) return false;

      return permissions.every(p => this.userPermissions[resource].includes(p));
    },
  },
};
